<template>
  <div class="row" v-if="multi_factor_key">
    <div
      class="col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide ? 'hidden-xs' : ''"
    >
      <div class="collapse-drop-label">Role:</div>
      <div>
        <span v-if="getRoleName(member.role_id)" class="custom-dropdown">
          {{ getRoleName(member.role_id) }}
        </span>
        <span v-else>
          <div v-if="member.role_id === 1">Account Owner</div>
          <div v-else-if="member.role_id === 5">Emergo alert admin</div>
          <div v-else-if="member.role_id === 7">Emergo alert writer</div>
        </span>
      </div>
    </div>
    <div
      class="col-lg-4 col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide ? 'hidden-xs' : ''"
    >
      <div class="collapse-drop-label">Distributor:</div>
      <div class="custom-dropdown">{{ getDistributorName(member.assigned_distributor_id) }}</div>
    </div>
    <div
      class="col-lg-4 col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide ? 'hidden-xs' : ''"
    >
      <div class="collapse-drop-label">IP Address:</div>
      <div class="custom-dropdown">{{ member.ip_address }}</div>
    </div>
  </div>
  <div class="row" v-else>
    <div
      class="col-md-6 col-sm-6 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide ? 'hidden-xs' : ''"
    >
      <div class="collapse-drop-label">Role:</div>
      <div>
        <span v-if="getRoleName(member.role_id)" class="custom-dropdown">
          {{ getRoleName(member.role_id) }}
        </span>
        <span v-else>
          <div v-if="member.role_id === 1">Account Owner</div>
          <div v-else-if="member.role_id === 5">Emergo alert admin</div>
          <div v-else-if="member.role_id === 7">Emergo alert writer</div>
        </span>
      </div>
    </div>
    <div
      class="col-md-6 col-sm-6 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide ? 'hidden-xs' : ''"
    >
      <div class="collapse-drop-label">Distributor:</div>
      <div class="custom-dropdown">{{ getDistributorName(member.assigned_distributor_id) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'roleId',
    'roles',
    'member',
    'localDistributors',
    'selectedRolesList',
    'xshide',
    'multi_factor_key'
  ],
  data() {
    return {
      selectedRole: {}
    };
  },
  created() {
    this.selectedRole = this.selectedRolesList;
  },
  watch: {
    selectedRolesList() {
      this.selectedRole = this.selectedRolesList;
    }
  },
  methods: {
    getRoleName(id) {
      const role = this.roles.find((r) => r.role_id === id);
      return role ? role.role_name : '';
    },
    getDistributorName(id) {
      const distributor = this.localDistributors.find((r) => r.id === id);
      return distributor ? distributor.distributor_name : '';
    },
    emitDistributor() {
      this.$emit('updateDistributor', {
        id: this.member.id,
        dist_id: this.member.assigned_distributor_id
      });
    },
    emitRole() {
      this.$emit('updateRole', {
        member: this.member,
        selectedId: this.selectedRole.id
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.collapse-drop-label {
  @include fontItems($font-14, 16px, $font-weight-medium);
  margin-left: 10px;
  margin-bottom: 4px;
  display: none;
}
::v-deep .custom-dropdown {
  .el-input__inner {
    @include fontItems($font-16, 19px, $font-weight-medium);
    color: $primary !important;
    border: 0.5px solid $deep-gray !important;
    border-radius: $radius20;
  }
  .el-select {
    width: 100%;
  }
}
.el-select-dropdown__item {
  &.selected {
    color: $primary;
    &::after {
      content: '';
      position: absolute;
      width: 1.6ex;
      height: 0.8ex;
      background: rgba(0, 0, 0, 0);
      top: 1.7ex;
      right: 15px;
      border: 3px solid $light-green;
      border-top: none;
      border-right: none;
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}
@media (min-width: 769px) and (max-width: 1150px) {
  .sm-txt-alg-lt {
    text-align: left !important;
  }
}
@media (max-width: 767px) {
  .custom-dropdown {
    margin-left: 10px;
    margin-bottom: 4px;
  }
  .display-flex-mobile {
    margin-bottom: 4px;
    display: flex;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
  .xs-mr-bt-10 {
    margin-bottom: 0px;
  }
  .xs-mr-tp-10 {
    margin-top: 10px;
  }
  .collapse-drop-label {
    display: block;
    font-size: $font-16;
    line-height: 22px;
    margin-right: 10px;
  }
}
</style>
